import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div style={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center' }}>
        <div className="spin" style={{ width: 28, height: 28, border: '3px solid var(--border)', borderTop: '3px solid var(--teal)', borderRadius: '50%' }} />
      </div>
    )
  }

  if (!user) return <Navigate to="/login" replace />

  return children
}
